import {
  useAuthentication,
  useRedirectOrigin
} from 'authentication/shared/hooks'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/js/bootstrap.js'

import EnvironmentAlert from 'infrastructure/Application/components/EnvironmentAlert'

import { Router as ApplicationRouter } from './components'

import 'shared/assets/css/fonts.css'
import useHandleLanguage from 'shared/hooks/useHandleLanguage'
import { FeedbackCardContainer } from '@yes.technology/react-toolkit'
import Loading from './components/Loading'
import { useSignUpPath } from 'authentication/SignUp'
import { useRecoverPasswordPath } from 'authentication/RecoverPassword'

export type ApiSystemType = { api: { isPending: boolean } }

const ApplicationContainer: React.FunctionComponent = (): JSX.Element => {
  const { isLoading } = useAuthentication()

  useRedirectOrigin()
  useHandleLanguage()
  useSignUpPath()
  useRecoverPasswordPath()

  return (
    <>
      <Loading active={isLoading} />
      <EnvironmentAlert environment={window.waEnv} />
      <ApplicationRouter />
      <FeedbackCardContainer />
    </>
  )
}

export default ApplicationContainer
